const Loading = () => {
  return (
    <div className="flex justify-center items-center h-screen dark:bg-slate-800">
      <div className="w-16 h-16 border-t-4 border-b-4 border-main rounded-full animate-spin"></div>
    </div>
  );
};

export default Loading;
